import { render, staticRenderFns } from "./ContentPlaceholdersHeading.vue?vue&type=template&id=f0e00b12"
import script from "./ContentPlaceholdersHeading.vue?vue&type=script&lang=js"
export * from "./ContentPlaceholdersHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports